import React from "react";
import image from "../../asset/Vision.png";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const Vision = () => {
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.2,
  });

  const { ref: refOne, inView: inViewOne } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const { ref: refTwo, inView: inViewTwo } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <div className="flex justify-center md:flex-row flex-col  items-center xl:gap-4 md:gap-3 gap-5 xl:px-[5%] lg:px-[3%] md:px-[2%] px-[6%] lg:py-16 md:py-10 py-6">
      <div
        ref={refOne}
        className={`flex-1 flex flex-col items-start justify-center xl:gap-5 lg:gap-3 gap-4 ${
          inViewOne ? "animate-slideRight" : "opacity-0"
        }`}
      >
        <div className="flex flex-col gap-2">
          <span className="xl:text-[2rem] md:text-[1.5rem] text-[1.8rem] uppercase font-semibold">
            Vision
          </span>
          <span className="text-[#7A7A7A] text-justify xl:text-[1.2rem] lg:text-[1rem] md:text-[.9rem] text-[1rem]">
            The authority is the principal development institution for district
            Rawalpindi, since 1989. RDA aims at enabling and facilitating
            provision of improved service delivery in Urban, Housing and
            Transportation sector in order to meet the emerging civic standards
            for residents of Rawalpindi.
          </span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="xl:text-[2rem] md:text-[1.5rem] text-[1.8rem] uppercase font-semibold">
            Territory
          </span>

          <span className="xl:text-[1.2rem] text-justify lg:text-[1rem] md:text-[.9rem] text-[1rem] text-[#7A7A7A]">
            Rawalpindi Development Authority is spread over the Municipal
            Committee Rawalpindi and 64 other Revenue Estates of Rawalpindi,
            except Cantonment Board. The controlled area of Rawalpindi
            Development Authority is around 311 Sq. Km.
          </span>
        </div>
        <div className="flex items-center w-full">
          <div className="flex-1 flex flex-col xl:text-[1.1rem] text-[.9rem] font-medium ">
            <span
              ref={ref}
              className="xl:text-[2.1rem] text-[1.5rem] font-bold text-[#00643b]"
            >
              {inView && <CountUp end={64} duration={3} />}
            </span>
            Revenue Estates of Rawalpindi
          </div>
          <div className="flex-1 flex flex-col xl:text-[1.1rem] text-[.9rem] font-medium ">
            <span className="xl:text-[2.1rem] text-[1.5rem] font-bold text-[#00643b]">
              <span ref={ref}>
                {inView && <CountUp end={311} duration={3} />}
              </span>{" "}
              Sq.Km
            </span>
            Controlled area
          </div>
        </div>
      </div>
      <div
        ref={refTwo}
        className={`lg:flex-1 md:w-[40%]  flex flex-col md:items-end items-center ${
          inViewTwo ? "animate-slideLeft" : "opacity-0"
        }`}
      >
        <img
          src={image}
          className="lg:w-[80%] md:w-[90%] w-[95%]  rounded-[.9rem]"
          alt=""
        />
        {/* <span className="flex text-[#00643b] font-semibold xl:text-[1.2rem] lg:text-[1rem] md:text-[.9rem] text-[1rem] items-center gap-2 cursor-pointer">
          Learn more <span className="xl:text-[2rem] text-[1.5rem]">→</span>
        </span> */}
      </div>
    </div>
  );
};

export default Vision;
